/**
 * Baptist Cancer Center Clinical Trial Search
 *
 * Replaces the previous Angular TrialsSearchController.
 *
 * Initial results are rendered server-side.
 * Subsequent filtering and pagination asynchronously request the
 * server-rendered Razor partial.
 */
(function ($) {
    'use strict';

    var SEARCH_ENDPOINT = '/api/sitecore/BccTrials/Search';

    $(document).ready(function () {
        $('[data-clinical-trial-search-component]').each(function () {
            initializeClinicalTrialSearch($(this));
        });
    });

    function initializeClinicalTrialSearch($component) {

        var $filterWrapper =
            $component.find('[data-clinical-trial-filter-wrapper]');

        var $loading =
            $component.find('[data-clinical-trial-loading]');

        /**
         * Get the current browser query string.
         */
        function getSearchParams() {
            return new URLSearchParams(
                window.location.search
            );
        }

        /**
         * Update the browser URL without reloading.
         *
         * Also keep Secondary Hero search forms synchronized with the
         * current asynchronous search state.
         */
        function updateBrowserUrl(searchParams) {

            var queryString =
                searchParams.toString();

            var newUrl =
                window.location.pathname +
                (queryString ? '?' + queryString : '') +
                window.location.hash;

            window.history.pushState(
                { path: newUrl },
                '',
                newUrl
            );

            $('form.bcc-search-form').each(function () {

                var $form = $(this);

                /*
                 * Remove previously generated search-state fields.
                 */
                $form
                    .find(
                        'input[type="hidden"][data-location-search-param]'
                    )
                    .remove();

                /*
                 * Re-add the current query-string state.
                 *
                 * q is skipped because the Secondary Hero already owns
                 * the visible search field named q.
                 */
                searchParams.forEach(function (value, key) {

                    if (key === 'q') {
                        return;
                    }

                    $('<input>', {
                        type: 'hidden',
                        name: key,
                        value: value,
                        'data-location-search-param': ''
                    }).appendTo($form);

                });

            });
        }

        /**
         * Add/update/remove a query-string parameter.
         */
        function setSearchParam(
            searchParams,
            key,
            value
        ) {

            if (value === null ||
                value === undefined ||
                value === '') {

                searchParams.delete(key);
            }
            else {
                searchParams.set(key, value);
            }
        }

        /**
         * Toggle loading indicator.
         */
        function setLoading(isLoading) {

            if (!$loading.length) {
                return;
            }

            if (isLoading) {
                $loading.show();
            }
            else {
                $loading.hide();
            }
        }

        /**
         * Retrieve and replace the server-rendered results partial.
         */
        function getResults(resetPage) {

            var searchParams =
                getSearchParams();

            if (resetPage) {
                searchParams.set('pg', '1');
            }

            updateBrowserUrl(
                searchParams
            );

            setLoading(true);

            $.ajax({
                url: SEARCH_ENDPOINT,
                method: 'GET',
                data: searchParams.toString(),
                cache: false
            })
                .done(function (html) {

                    var $currentResults =
                        $component.find(
                            '[data-clinical-trial-results-container]'
                        );

                    $currentResults.replaceWith(
                        html
                    );

                })
                .fail(function () {

                    alert(
                        'Error getting events.'
                    );

                })
                .always(function () {

                    setLoading(false);

                });
        }

        /**
         * Set Anatomic Site.
         */
        $component.on(
            'click',
            '[data-clinical-trial-site]',
            function (e) {

                e.preventDefault();

                var site =
                    $(this).attr(
                        'data-clinical-trial-site'
                    );

                var searchParams =
                    getSearchParams();

                setSearchParam(
                    searchParams,
                    's',
                    site
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Update the visible filter label immediately.
                 */
                $component
                    .find('[data-clinical-trial-site-label]')
                    .text(site);

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear Anatomic Site.
         */
        $component.on(
            'click',
            '[data-clinical-trial-clear-site]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('s');

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-clinical-trial-site-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Set Trial Type.
         */
        $component.on(
            'click',
            '[data-clinical-trial-type]',
            function (e) {

                e.preventDefault();

                var type =
                    $(this).attr(
                        'data-clinical-trial-type'
                    );

                var searchParams =
                    getSearchParams();

                setSearchParam(
                    searchParams,
                    't',
                    type
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Update the visible filter label immediately.
                 */
                $component
                    .find('[data-clinical-trial-type-label]')
                    .text(type);

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear Trial Type.
         */
        $component.on(
            'click',
            '[data-clinical-trial-clear-type]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('t');

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-clinical-trial-type-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Set Trial Phase.
         */
        $component.on(
            'click',
            '[data-clinical-trial-phase]',
            function (e) {

                e.preventDefault();

                var phase =
                    $(this).attr(
                        'data-clinical-trial-phase'
                    );

                var searchParams =
                    getSearchParams();

                setSearchParam(
                    searchParams,
                    'p',
                    phase
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Update the visible filter label immediately.
                 */
                $component
                    .find('[data-clinical-trial-phase-label]')
                    .text(phase);

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear Trial Phase.
         */
        $component.on(
            'click',
            '[data-clinical-trial-clear-phase]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('p');

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-clinical-trial-phase-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear all filters.
         *
         * Unlike the old Angular implementation, this performs only ONE
         * search request rather than clearing each filter individually.
         */
        $component.on(
            'click',
            '[data-clinical-trial-clear-all]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('s');
                searchParams.delete('t');
                searchParams.delete('p');

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Reset all visible filter labels.
                 */
                $component
                    .find('[data-clinical-trial-site-label]')
                    .text('Select');

                $component
                    .find('[data-clinical-trial-type-label]')
                    .text('Select');

                $component
                    .find('[data-clinical-trial-phase-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Pagination.
         */
        $component.on(
            'click',
            '[data-clinical-trial-page]',
            function (e) {

                e.preventDefault();

                var page =
                    parseInt(
                        $(this).attr(
                            'data-clinical-trial-page'
                        ),
                        10
                    );

                if (!page ||
                    page < 1) {

                    return;
                }

                var searchParams =
                    getSearchParams();

                searchParams.set(
                    'pg',
                    page
                );

                updateBrowserUrl(
                    searchParams
                );

                /*
                 * Preserve the old Angular behavior:
                 * scroll back to the top of the clinical trial component
                 * when changing pages.
                 */
                var $searchComponent =
                    $('.component-clinical-trial-search');

                if ($searchComponent.length) {

                    $(
                        [
                            document.documentElement,
                            document.body
                        ]
                    ).animate(
                        {
                            scrollTop:
                                $searchComponent
                                    .offset()
                                    .top
                        },
                        400
                    );
                }

                getResults(false);
            }
        );

        /**
         * Additional Details expand/collapse.
         *
         * Delegated because the result cards are replaced after every
         * asynchronous search.
         */
        $component.on(
            'click',
            '[data-clinical-trial-details-toggle]',
            function (e) {

                e.preventDefault();

                var id =
                    $(this).attr(
                        'data-clinical-trial-details-toggle'
                    );

                var $details =
                    $('#' + id);

                if (!$details.length) {
                    return;
                }

                $details.slideToggle();

                var $parent =
                    $details.parent();

                $parent.toggleClass(
                    'open'
                );
            }
        );

        /**
         * Mobile filter panel.
         */
        $component.on(
            'click',
            '[data-clinical-trial-mobile-filter-open]',
            function (e) {

                e.preventDefault();

                $filterWrapper.addClass(
                    'show'
                );
            }
        );

        $component.on(
            'click',
            '[data-clinical-trial-mobile-filter-close]',
            function (e) {

                e.preventDefault();

                $filterWrapper.removeClass(
                    'show'
                );
            }
        );

        /**
         * Browser Back / Forward.
         *
         * Reloading guarantees the complete SSR state, including filter
         * labels and facet counts, matches the restored URL.
         */
        $(window).on(
            'popstate.clinicalTrialSearch-' +
            $component.attr('id'),
            function () {

                window.location.reload();

            }
        );
    }

})(jQuery);